import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LeaderboardEntry } from '../../../../../core/interfaces/gamification';

@Component({
  selector: 'app-leaderboard-card',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './leaderboard-card.component.html',
  styleUrl: './leaderboard-card.component.css',
})
export class LeaderboardCardComponent {
  @Input() entries: LeaderboardEntry[] = [];
  @Input() titleKey: string = 'DASHBOARD.LEADERBOARD.TITLE';
  @Input() loading = false;

  readonly rankIcons: Record<number, string> = {
    1: 'fa-solid fa-trophy',
    2: 'fa-solid fa-medal',
    3: 'fa-solid fa-award',
  };

  readonly rankColors: Record<number, string> = {
    1: '#FFD700',
    2: '#C0C0C0',
    3: '#CD7F32',
  };

  getRankIcon(rank: number): string {
    return this.rankIcons[rank] ?? 'fa-solid fa-star';
  }

  getRankColor(rank: number): string {
    return this.rankColors[rank] ?? 'var(--cpurple1)';
  }

  getInitials(entry: LeaderboardEntry): string {
    return (
      (entry.firstName?.[0] ?? '') + (entry.lastName?.[0] ?? '')
    ).toUpperCase();
  }
}
